<template>
  <b-overlay
    :show="loadingOverlay"
    rounded="sm"
  >
    <div class="sf-about-card">
      <div class="sf-about-head">
        <div class="sf-about-avatar">
          <b-img
            :src="getlogo(user_data.id)"
            rounded
            fluid
            alt="profile photo"
          />
        </div>
        <div class="sf-about-idcol">
          <h2 class="sf-about-name">
            {{ user_data.nome }}
          </h2>
          <p class="sf-about-role">
            {{ user_data.perfil }}
          </p>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import {
  BOverlay, BImg,
} from 'bootstrap-vue'

export default {

  components: {
    BOverlay,
    BImg,
  },

  data() {
    return {
      loadingOverlay: false,
      user_data: [],
    }
  },

  created() {
    this.getMeuAgente(this.$route.params.id)
  },

  methods: {
    getlogo(id) {
      return `${process.env.VUE_APP_STATIC}agente/${id}/logo.png`
    },

    getMeuAgente(id) {
      this.loadingOverlay = true
      this.$store.dispatch('meu-agente-fut/getMeuAgenteSobre', id)
        .then(res => { this.user_data = res.data })
        .finally(() => {
          this.loadingOverlay = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
/* Sobre — card Soulf (redesign) */
.sf-about-card {
  background: #0F0F11;
  border: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: 16px;
  padding: 24px;
}
.sf-about-head {
  display: flex;
  align-items: center;
  gap: 18px;
}
.sf-about-avatar {
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  border-radius: 14px;
  overflow: hidden;
  background: #1C1C1E;
  border: 1px solid rgba(255, 255, 255, 0.10);

  ::v-deep img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.sf-about-idcol { min-width: 0; }
.sf-about-name {
  font-family: 'Geist', sans-serif;
  font-weight: 600;
  font-size: 19px;
  color: #fff;
  margin: 0 0 4px;
}
.sf-about-role {
  font-family: 'Geist', sans-serif;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
  margin: 0;
}
</style>
